'use client'

import cx from 'classnames'
import Link, { LinkProps } from 'next/link'
import { HTMLAttributeAnchorTarget } from 'react'
import s from './button.module.css'

interface IButtonProps {
  children: React.ReactNode
  disabled?: boolean
  href?: LinkProps['href']
  rel?: string
  className?: string
  variant?: 'primary' | 'secondary' | 'transparent'
}

export const Button = ({
  children,
  href,
  className,
  variant = 'primary',
  ...props
}: IButtonProps &
  (
    | React.ComponentProps<'button'>
    | (LinkProps & { target?: HTMLAttributeAnchorTarget })
  )) => {
  const getButtonType = () => {
    switch (variant) {
      case 'primary':
        return s.primary
      case 'secondary':
        return s.secondary
      case 'transparent':
        return s.transparent
      default:
        return s.primary
    }
  }

  const buttonType = getButtonType()

  return (
    <>
      {href ? (
        <Link
          {...(props as LinkProps)}
          href={href}
          aria-disabled={props.disabled}
          tabIndex={props.disabled ? -1 : undefined}
          className={cx(s.button, buttonType, className, {
            [s.disabled]: props.disabled,
          })}
        >
          {children}
        </Link>
      ) : (
        <button
          {...(props as React.ComponentProps<'button'>)}
          disabled={props.disabled}
          className={cx(s.button, buttonType, className, {
            [s.disabled]: props.disabled,
          })}
        >
          {children}
        </button>
      )}
    </>
  )
}
